export class Sidebar{

	constructor() {

		this.window = $(window);
		this.sidebar = $('.sidebar__content');
		this.header = $('header');
		this.footer = $('.c-footer');
		this.button= $('.js-showsidebar');

		this.canFixed = false;
		this.isFixed = false;

		this.sLeft;
		this.sTop;
		this.sWidth;

		if( ! Modernizr.mobile && $(window).outerWidth() > 768 ){
			this.calcParams();
			this.actions();
		}else{
			this.actionsMobile();
		}

	}

	calcParams(){

		if( ( this.window.outerHeight() - this.header.outerHeight() - this.footer.outerHeight() + 20 ) > this.sidebar.outerHeight() + 30 ){
			this.canFixed = true;

			this.sLeft = this.sidebar.offset().left;
			this.fixedAt = this.sidebar.offset().top - this.header.outerHeight() - 20;
			this.sTop =  this.header.outerHeight() + 20;
			this.sWidth = this.sidebar.outerWidth();

			this.addFixed();
		}else{
			this.canFixed = false;

			if( this.isFixed ){
				this.removeFixed();
			}
		}

	}

	actions() {

		this.pageScroll();
		this.window.on( 'scroll' , this.pageScroll.bind(this) );
		this.window.on( 'resize' , this.calcParams.bind(this) );
	}

	actionsMobile() {
		this.button.on('click', (event) => {
			this.sidebar.toggleClass('is-visible');
		});
	}

	pageScroll(){

		if( this.window.scrollTop() >= this.fixedAt && this.canFixed && ! this.isFixed ){
			this.addFixed();
		}else if( this.window.scrollTop() < this.fixedAt && this.isFixed ){
			this.removeFixed();
		}

	}

	addFixed(){
		this.isFixed = true;

		this.sidebar.css({
			'position': 'fixed',
			'top': this.sTop,
			'left': this.sLeft,
			'width': this.sWidth
		});
	}

	removeFixed(){
		this.isFixed = false;
		this.sidebar.removeAttr('style');
	}

}


// WEBPACK FOOTER //
// ./src/js/modules/sidebar.js